export enum DigitalHospitalSteps {
  DISABLED = 'disabled',
  ENABLED = 'enabled',
}
